import { useEffect } from 'react'
import ContentstackLivePreview from '@contentstack/live-preview-utils'

let isInitialised = false
const CONTENT_STACK_APIKEY = process.env.NEXT_PUBLIC_CONTENTSTACK_API_KEY

const initContentStackLivePreview = async () => {
  if (isInitialised) {
    return undefined
  }

  isInitialised = true
  try {
    if (CONTENT_STACK_APIKEY) {
      return await ContentstackLivePreview.init({
        stackDetails: {
          apiKey: CONTENT_STACK_APIKEY,
        },
      })
    }

    return await ContentstackLivePreview.init()

  } catch (error) {
    return undefined
  }
}

const ContentStackInitialize = (): React.JSX.Element => {
  useEffect(() => {
    initContentStackLivePreview()
  }, [])
  return null
}

export default ContentStackInitialize
